import { useCallback, useState } from 'react';
import { getHeaderNavSpotlightSeen, setHeaderNavSpotlightSeen } from '../services/headerNavSpotlightService';

/**
 * One-time "My CV / My Skills moved" callout for Manager/Admin roles, shown
 * once per browser after the header nav redesign (ADR_2026-07-21_01) and
 * dismissed permanently after first acknowledgement.
 */
export const useHeaderNavSpotlight = (shouldOffer: boolean) => {
    const [seen, setSeen] = useState(getHeaderNavSpotlightSeen);

    const dismiss = useCallback(() => {
        setHeaderNavSpotlightSeen();
        setSeen(true);
    }, []);

    return { showSpotlight: shouldOffer && !seen, dismiss };
};
